import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import EffectiveTaxRateForm from '../../reports/viewEffectiveTaxRatePage/effectiveTaxRateForm.component';
import EffectiveTaxRateReport from '../../reports/viewEffectiveTaxRatePage/effectiveTaxRateReport.component';

import {
  selectSlGroupTypes,
  countryTaxTypesStatutoryTaxRatesSelector,
  countryTaxTypesSelector,
  reportDataSelector,
  detailedCountryTaxTypesDataSelector,
  hasAnyCompanyCodesForManagingETRDriversSelector,
} from '../../reports/viewEffectiveTaxRatePage/store/selectors';

import {
  selectCountryTaxType,
  selectStatutoryTaxRate,
  fetchCountryTaxTypesAndRates,
  fetchReport,
  showDeletingDriverModal,
  resetCountryTaxTypesAndRates,
  resetETRReport,
  toggleVisibility,
} from '../../reports/viewEffectiveTaxRatePage/store/actions';

import {
  isInCurrentPeriodSelector,
  reportingCurrencyCodeSelector,
  periodOrCurrentSelector,
  userSelector,
} from '../../shared/store/selectors';

import { listItemPropTypes } from '../../shared/propTypes';

import { modalDataSelector } from '../../shared/modals/modals.selectors';

import ModalNames from '../../reports/viewEffectiveTaxRatePage/modalNames';

import { EffectiveTaxRateReportPropTypes, DetailedCountryTaxTypesDataPropTypes } from '../../reports/viewEffectiveTaxRatePage/propTypes';
import { UserWithoutActiveFlagPropTypes } from '../../shared/propTypes/users';

class EffectiveTaxRateTab extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    companyCode: PropTypes.string.isRequired,
    allCountryTaxTypes: PropTypes.arrayOf(listItemPropTypes).isRequired,
    selectedCountryTaxTypes: PropTypes.arrayOf(listItemPropTypes).isRequired,
    allStatutoryTaxRates: PropTypes.arrayOf(listItemPropTypes).isRequired,
    statutoryTaxRate: listItemPropTypes,
    selectCountryTaxType: PropTypes.func.isRequired,
    selectStatutoryTaxRate: PropTypes.func.isRequired,
    fetchCountryTaxTypesAndRates: PropTypes.func.isRequired,
    reportData: EffectiveTaxRateReportPropTypes,
    fetchReport: PropTypes.func.isRequired,
    resetCountryTaxTypesAndRates: PropTypes.func.isRequired,
    resetETRReport: PropTypes.func.isRequired,
    detailedCountryTaxTypesData: DetailedCountryTaxTypesDataPropTypes.isRequired,
    confirmDeletingDriverModalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
    }).isRequired,
    showDeletingDriverModal: PropTypes.func.isRequired,
    user: UserWithoutActiveFlagPropTypes.isRequired,
    isInCurrentPeriod: PropTypes.bool.isRequired,
    reportingCurrencyCode: PropTypes.string.isRequired,
    isFetchingReportData: PropTypes.bool.isRequired,
    hasAnyCompanyCodesForManagingETRDrivers: PropTypes.func.isRequired,
    toggleVisibility: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const {
      fetchCountryTaxTypesAndRates,
      period,
      companyCode,
    } = this.props;

    fetchCountryTaxTypesAndRates({
      periodName: period.name,
      groupType: 'CC',
      groupItem: companyCode,
    });
  }

  componentWillUnmount() {
    this.props.resetCountryTaxTypesAndRates();
    this.props.resetETRReport();
  }

  selectCountryTaxType = countryTaxTypes => {
    this.props.selectCountryTaxType(countryTaxTypes);
  };

  selectStatutoryTaxRate = statutoryTaxRate => {
    this.props.selectStatutoryTaxRate(statutoryTaxRate);
  };

  fetchReport = () => {
    const {
      fetchReport,
      period,
      companyCode,
      statutoryTaxRate,
      selectedCountryTaxTypes,
      detailedCountryTaxTypesData,
    } = this.props;

    fetchReport({
      periodName: period.name,
      groupType: 'CC',
      groupItem: companyCode,
      groupBy: 'CC',
      statutoryTaxRate,
      countryTaxTypes: selectedCountryTaxTypes,
      detailedCountryTaxTypesData,
    });
  };

  render() {
    const {
      allCountryTaxTypes,
      selectedCountryTaxTypes,
      allStatutoryTaxRates,
      statutoryTaxRate,
      companyCode,
      period,
      reportData,
      confirmDeletingDriverModalData,
      showDeletingDriverModal,
      user,
      isInCurrentPeriod,
      isFetchingReportData,
      hasAnyCompanyCodesForManagingETRDrivers,
      toggleVisibility,
      reportingCurrencyCode,
    } = this.props;

    return (
      <div>
        <EffectiveTaxRateForm
          allCountryTaxTypes={allCountryTaxTypes}
          selectedCountryTaxTypes={selectedCountryTaxTypes}
          allStatutoryTaxRates={allStatutoryTaxRates}
          statutoryTaxRate={statutoryTaxRate}
          selectCountryTaxType={this.selectCountryTaxType}
          selectStatutoryTaxRate={this.selectStatutoryTaxRate}
          groupType="CC"
          groupItem={companyCode}
          groupBy="CC"
          periodName={period.name}
          showCurrencyControl
          fetchReport={this.fetchReport}
        />
        <div className="row no-gutters">
          <div className="col">
            <EffectiveTaxRateReport
              reportData={reportData}
              fetchReport={this.fetchReport}
              confirmDeletingDriverModalData={confirmDeletingDriverModalData}
              showDeletingDriverModal={showDeletingDriverModal}
              user={user}
              isInCurrentPeriod={isInCurrentPeriod}
              reportingCurrencyCode={reportingCurrencyCode}
              suppressHidingDecimalPlacesForPercentage
              isLoading={isFetchingReportData}
              hideGroupingColumns
              totalColumnName={companyCode}
              hasAnyCompanyCodesForManagingETRDrivers={hasAnyCompanyCodesForManagingETRDrivers}
              displayGroupingColumnsByPercentages={false}
              toggleVisibility={toggleVisibility}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    period: periodOrCurrentSelector(state),
    groupTypes: selectSlGroupTypes(state),
    companyCode: state.shared.companyCode,
    allCountryTaxTypes: countryTaxTypesSelector(state),
    selectedCountryTaxTypes: state.reports.effectiveTaxRate.selectedCountryTaxTypes,
    allStatutoryTaxRates: countryTaxTypesStatutoryTaxRatesSelector(state),
    statutoryTaxRate: state.reports.effectiveTaxRate.statutoryTaxRate,
    reportData: reportDataSelector(state),
    detailedCountryTaxTypesData: detailedCountryTaxTypesDataSelector(state),
    confirmDeletingDriverModalData: modalDataSelector(state, ModalNames.ConfirmDeletingDriver),
    user: userSelector(state),
    isInCurrentPeriod: isInCurrentPeriodSelector(state),
    reportingCurrencyCode: reportingCurrencyCodeSelector(state),
    isFetchingReportData: state.reports.effectiveTaxRate.isFetchingReportData,
    hasAnyCompanyCodesForManagingETRDrivers: hasAnyCompanyCodesForManagingETRDriversSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    selectCountryTaxType,
    selectStatutoryTaxRate,
    fetchCountryTaxTypesAndRates,
    fetchReport,
    showDeletingDriverModal,
    resetCountryTaxTypesAndRates,
    resetETRReport,
    toggleVisibility,
  }
)(EffectiveTaxRateTab);
